import { StoresSectionProps } from './stores-section.types'
import styles from './stores-section.module.scss'
// import cl from 'classnames'
import { SectionContainer } from '@touche-lts/panel-ui/dist/components/shared/section-container'
import { H2 } from '@touche-lts/panel-ui/dist/components/shared/h2'
import { EntitySearchInput } from 'components'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { AssignedStoresTable } from './assigned-stores-table'
import { NoneLabel } from '@touche-lts/panel-ui/dist'

const StoresSectionComponent = (props: StoresSectionProps) => {
  const { ...sectionContainerProps } = props

  const {
    storeSearchStore: {
      onComponentMount,
      clearStore,
      searchInput,
      onSearchInputChange,
      noResultsMessage,
      searchResultsToDisplay
    },
    userProfilePageStore: { hasAssignedStores },
    routingStore: { push }
  } = useRootStore()

  useEffect(() => {
    onComponentMount()
    return clearStore
  }, [onComponentMount, clearStore])

  return (
    <SectionContainer {...sectionContainerProps}>
      <div className={styles.headerContainer}>
        <H2>Stores</H2>
        <EntitySearchInput
          inputLabel='Assign a store'
          inputProps={{
            placeholder: 'Search for a store...',
            value: searchInput,
            onChange: onSearchInputChange
          }}
          noResultsMessage={noResultsMessage}
          searchResults={searchResultsToDisplay}
          addNewEntityProps={{
            addButtonProps: {
              children: 'Add a new store',
              onClick: () => push('/stores/add')
            }
          }}
        />
      </div>
      {hasAssignedStores ? (
        <AssignedStoresTable />
      ) : (
        <NoneLabel label='No stores assigned to this user yet.' />
      )}
    </SectionContainer>
  )
}

const StoresSection = observer(StoresSectionComponent)
export { StoresSection }
